import React from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import { Add, Delete } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';
import { wsRemove } from 'services/WService';
import AddComboModal from './AddComboModal';
import { useModal } from 'hooks/useModal';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código Producto', accessor: 'Code' },
  { Header: 'Descripción', accessor: 'ItemName' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function ComboProducts(props) {
  const { combos, promotion, showNotify, reload } = props;
  const [addComboModel, setAddComboModel] = useModal();

  async function removeCombo(logiProductId) {
    let res = await wsRemove(`prom/promotion/${promotion.id}/combo`, logiProductId);
    if (res.success) {
      showNotify(res.message);
      reload();
    } else {
      showNotify(res.message, 'error');
    }
  }

  return (
    <GridItem xs={12}>
      <CardContainer
        title="Combos afectos"
        icon={<Add />}
        onClick={() => {
          setAddComboModel({ base_business_partner_id: promotion.base_business_partner_id });
        }}
      >
        <AddComboModal
          model={addComboModel}
          promotion={promotion}
          setOpen={setAddComboModel}
          showNotify={showNotify}
          reload={reload}
        />
        <ReactTable
          columns={columns}
          data={combos.map((combo, index) => {
            return {
              num: (
                <div className="actions-right">
                  {index + 1}
                  <Button
                    justIcon
                    round
                    simple
                    color="danger"
                    onClick={() => removeCombo(combo.logi_product_id)}
                  >
                    <Delete />
                  </Button>
                </div>
              ),
              Code: combo.ItemCode,
              ItemName: combo.ItemName,
            };
          })}
          exportExcel={false}
        />
      </CardContainer>
    </GridItem>
  );
}

export default ComboProducts;
